{
  "appointment": {
    "CONFIRMATION_NUMBER": "Confirmação #",
    "APPOINTMENT_ID": "ID do agendamento",
    "APPOINTMENT_DATE": "Data do agendamento",
    "APPOINTMENT_TIME": "Hora do agendamento",
    "APPOINTMENT_TIMEZONE": "Fuso horário",
    "APPOINTMENT_TYPE": "Tipo de agendamento",
    "SCHEDULED_DURATION": "Duração agendada (min)",
    "STATUS": "Status",
    "ARRIVAL_DATE": "Data de chegada",
    "ARRIVAL_TIME": "Hora de chegada",
    "DEPARTURE_DATE": "Data de saída",
    "DEPARTURE_TIME": "Hora de saída",
    "DWELL_TIME": "Tempo de permanência (min)",
    "ON_TIME": "Pontualidade (min)",
    "IN_PROGRESS_DATE": "Data de início (em andamento)",
    "IN_PROGRESS_TIME": "Hora de início (em andamento)",
    "WAIT_TIME": "Tempo de espera (min)",
    "PROCESSING_TIME": "Tempo de processamento (min)",
    "WAREHOUSE": "Armazém",
    "DOCK": "Doca",
    "LOAD_TYPE": "Tipo de carga",
    "LOAD_TYPE_DIRECTION": "Direção",
    "RESCHEDULE_COUNT": "Número de reagendamentos",
    "CREATED_BY": "Criado por",
    "CREATOR_TYPE": "Tipo de criador",
    "CREATION_DATE": "Data de criação",
    "LAST_UPDATED_BY": "Última atualização por",
    "LAST_UPDATE_DATE": "Data da última atualização",
    "LAST_UPDATE_TIME": "Hora da última atualização",
    "CARRIER_COMPANY": "Transportadora",
    "CONTACT_NAME": "Nome do contato",
    "CONTACT_EMAIL": "E-mail do contato",
    "CONTACT_PHONE": "Telefone do contato",
    "NOTES": "Notas",
    "TAGS": "Tags",
    "CUSTOM_FIELDS": "Campos personalizados",
    "EXTERNAL_VALIDATION_STATUS": "Status de validação externa",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "Mensagem de erro de validação externa",
    "CheckOut": "Saída",
    "CheckInAdditionalAssetDetails": "Detalhes adicionais do ativo na entrada",
    "InboundClaim": "Reclamação de entrada",
    "OutboundClaim": "Reclamação de saída",
    "BookLoadType": "Tipo de carga do agendamento",
    "AssetContainerDetails": "Detalhes do contêiner do ativo",
    "AppointmentCompleted": "Agendamento concluído"
  },
  "assetVisit": {
    "id": "ID da visita",
    "appointmentId": "ID do agendamento",
    "checkInDate": "Data de entrada",
    "checkOutDate": "Data de saída",
    "carrier": "Transportadora",
    "warehouseName": "Armazém",
    "currentStatus": "Status",
    "licensePlate": "Placa",
    "visitType": "Tipo de visita",
    "dotNumber": "Número DOT",
    "phone": "Telefone",
    "isPlanned": "Planejada",
    "driverNotes": "Observações do motorista",
    "checkInAcknowledged": "Entrada confirmada",
    "firstName": "Nome (verificação de ID)",
    "lastName": "Sobrenome (verificação de ID)",
    "birthdate": "Data de nascimento (verificação de ID)",
    "idValidationEmail": "E-mail (verificação de ID)",
    "idValidationPhone": "Telefone (verificação de ID)"
  }
}
